/** relative_detail_url 是否为站外完整 URL */
export function isExternalRelativeDetailUrl(relativeDetailUrl) {
    return /^https?:\/\//i.test((relativeDetailUrl || '').trim());
}
/** 站外 URL；非外链返回 null */
export function getExternalRelativeDetailUrl(relativeDetailUrl) {
    var value = (relativeDetailUrl || '').trim();
    return isExternalRelativeDetailUrl(value) ? value : null;
}
/** relative_detail_url → 帮助页 product 段，如 /audio/Viwoo → audio/Viwoo */
export function helpPathFromRelativeUrl(relativeDetailUrl) {
    if (!relativeDetailUrl || relativeDetailUrl === '/') {
        return '';
    }
    if (isExternalRelativeDetailUrl(relativeDetailUrl)) {
        return '';
    }
    return relativeDetailUrl.replace(/^\//, '').split('?')[0];
}
/** 优先 relative_detail_url，缺失时从 details_url 解析 pathname 回退 */
export function helpPathFromProduct(relativeDetailUrl, detailsUrl) {
    var fromRelative = helpPathFromRelativeUrl(relativeDetailUrl);
    if (fromRelative) {
        return fromRelative;
    }
    if (!detailsUrl) {
        return '';
    }
    if (/^https?:\/\//i.test(detailsUrl)) {
        try {
            return helpPathFromRelativeUrl(new URL(detailsUrl).pathname);
        }
        catch (_a) {
            return '';
        }
    }
    return helpPathFromRelativeUrl(detailsUrl);
}
/** 帮助中心产品一览表 → 软件教程列表页，可选带上已选产品 */
export function buildHelpArticleListUrl(relativeDetailUrl, classify, detailsUrl) {
    if (classify === void 0) { classify = 'article'; }
    var path = helpPathFromProduct(relativeDetailUrl, detailsUrl);
    return path ? "/".concat(classify, "/").concat(path) : "/".concat(classify);
}
/** 帮助首页产品一览表卡片 href：外链直跳，相对路径走 /article */
export function buildGuideProductLink(relativeDetailUrl, classify, detailsUrl) {
    if (classify === void 0) { classify = 'article'; }
    var external = getExternalRelativeDetailUrl(relativeDetailUrl);
    if (external) {
        return external;
    }
    return buildHelpArticleListUrl(relativeDetailUrl, classify, detailsUrl);
}
